<mat-tab-group [mat-stretch-tabs]="false" class="h-full">
  <mat-tab [label]="'personal_content.collection_types.favorites' | transloco">
    <pc-plugin-favorite-list
      [compact]="compact"
      [items]="favoriteCollections$ | async"
      type="favorites"
    ></pc-plugin-favorite-list>
  </mat-tab>
  @if (!hideCollections) {
  <mat-tab [label]="'personal_content.collection_types.general' | transloco">
    <pc-plugin-favorite-list
      [compact]="compact"
      [items]="generalCollections$ | async"
      type="general"
    ></pc-plugin-favorite-list>
  </mat-tab>
  } @if (!hideCollections && !hideDidacticCollections) {
  <mat-tab [label]="'personal_content.collection_types.didactic' | transloco">
    <pc-plugin-favorite-list
      [compact]="compact"
      [items]="didacticCollections$ | async"
      type="didactic"
    ></pc-plugin-favorite-list>
  </mat-tab>
  } @if (!hideCollections) {
  <mat-tab [label]="'personal_content.collection_types.trashbin' | transloco">
    <pc-plugin-favorite-list
      [compact]="compact"
      [items]="trashbinCollections$ | async"
      type="trashbin"
    ></pc-plugin-favorite-list>
  </mat-tab>
  }
</mat-tab-group>
